import {
	SET_CURRENT_CLIENT_ID,
	FETCH_ALL_CLIENTS,
	SET_CLIENT,
	UPDATE_CLIENT,
	SET_DOMAIN,
	DELETE_DOMAIN,
} from '../actions/actionTypes';
import { arrToObj } from '../util';
import omit from 'lodash/omit';

const preState = {
	clients: {},
	currentClient: {},
};

const clientReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, clients, clientID, domain, domainIDClientID } = action;
	const client = action.client?.domains
		? { ...action.client, domains: arrToObj(action.client.domains) }
		: action.client;

	switch (type) {
		case FETCH_ALL_CLIENTS:
			stateDup.clients = { ...arrToObj(clients) };
			return stateDup;
		case SET_CLIENT:
			stateDup.clients = { ...stateDup.clients, [client.id]: client };
			stateDup.currentClient = { ...client };
			return stateDup;
		case UPDATE_CLIENT:
			const newClient = { ...stateDup.clients[client.id], ...client };
			stateDup.clients = { ...stateDup.clients, [client.id]: newClient };
			if (stateDup.currentClient.id === client.id) stateDup.currentClient = newClient;
			return stateDup;
		case SET_DOMAIN: {
			const owner = stateDup.clients[domain.client_id];
			if (owner) {
				stateDup.clients = {
					...stateDup.clients,
					[domain.client_id]: { ...owner, domains: { ...owner.domains, [domain.id]: domain } },
				};
			}
			if (stateDup.currentClient.id === domain.client_id) {
				stateDup.currentClient = {
					...stateDup.currentClient,
					domains: { ...stateDup.currentClient.domains, [domain.id]: domain },
				};
			}
			return stateDup;
		}
		case DELETE_DOMAIN: {
			const { domainID, clientID: domainClientID } = domainIDClientID;
			const owner = stateDup.clients[domainClientID];
			if (owner) {
				stateDup.clients = {
					...stateDup.clients,
					[domainClientID]: { ...owner, domains: omit(owner.domains, domainID) },
				};
			}
			if (stateDup.currentClient.id === domainClientID) {
				stateDup.currentClient = {
					...stateDup.currentClient,
					domains: omit(stateDup.currentClient.domains, domainID),
				};
			}
			return stateDup;
		}
		case SET_CURRENT_CLIENT_ID:
			if (!stateDup.currentClient || clientID !== stateDup.currentClient.id) {
				stateDup.currentClient = stateDup.clients[clientID] || {};
			}
			return stateDup;
		default:
			return state;
	}
};

export default clientReducer;
